import React from 'react';
import { Button, ScrollView } from '@applane/react-core-components';
import { View, Image } from '../app-components';
import { appraiseLogo } from '../images';
import CardBox from './CardBox';
import HomeStyle from './HomeStyle';

export default ({ navigation }) => (
  <ScrollView style={{ flex: 1 }}>
    <View style={HomeStyle.boxToHoldTopBar}>
      <View style={HomeStyle.boxToHoldLogo}>
        <Button
          style={{ cursor: 'pointer' }}
          onClick={() => {
            window.location.replace('/');
          }}
        >
          <Image
            source={appraiseLogo}
            style={HomeStyle.logoIconProperties}
          />
        </Button>
      </View>
      <View style={HomeStyle.boxtoHoldHomeTCWorks}>
        <Button
          style={HomeStyle.htcwButtonProperties}
          onClick={() => {
            window.location.replace('/');
          }}
        >
          Home
        </Button>
        <Button
          style={HomeStyle.htcwButtonProperties}
          onClick={() => {
            navigation.replace('termsAndConditions');
          }}
        >
          Terms & Conditions
        </Button>
        <Button
          style={HomeStyle.htcwButtonProperties}
          onClick={() => {
            navigation.replace('howitworks');
          }}
        >
          How it Works
        </Button>
      </View>
      <View style={HomeStyle.boxToHoldLoginSignupButtons}>
        <View style={HomeStyle.boxToHoldSignupButton}>
          <Button
            style={HomeStyle.loginButtonProperties}
            onClick={() => {
              navigation.replace('login');
            }}
          >
            Login
          </Button>
        </View>
        <View style={HomeStyle.boxToHoldSignupButton}>
          <Button
            style={HomeStyle.signupButtonProperties}
            onClick={() => {
              navigation.replace('signup');
            }}
          >
            Sign up
          </Button>
        </View>
      </View>
    </View>
    <View style={HomeStyle.mainHeading}>Terms & Conditions</View>
    <View style={HomeStyle.heading}>
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
      tempor incididunt ut labore et dolore magna aliqua.
      {' '}
    </View>
    <View style={HomeStyle.flexBox}>
      <CardBox />
      <CardBox />
      <CardBox />
      <CardBox />
    </View>
  </ScrollView>
);
